import { tw } from "@careinfo/tailwind";
import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    console.error(err.message);
    console.info(props);
    return (
      <div
        className={tw`grid h-[100svh] w-full place-items-center place-content-center px-4`}
      >
        <div>
          <p className={tw`text-3xl font-bold text-red-600 text-center`}>
            Something went wrong
          </p>
          <p>{info.componentStack}</p>
        </div>
      </div>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
